// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["assets/styles/frontend","assets/styles/admin"], () => (__webpack_require__("./src/scripts/admin.js")))
__webpack_require__.O(undefined, ["assets/styles/frontend","assets/styles/admin"], () => (__webpack_require__("./src/styles/admin.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/styles/frontend","assets/styles/admin"], () => (__webpack_require__("./src/styles/frontend.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
